var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCurveShapeDesktop = function SvgCurveShapeDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 69,
    viewBox: "0 0 1500 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324 0S991.516 6.965 662.132 4.088C332.748 1.211 0 14.686 0 14.686V61a8 8 0 0 0 8 8h1308c4.42 0 183-3.582 183-8V0Z",
    fill: "#F7F3F0"
  })));
};
export default SvgCurveShapeDesktop;